import { dispatchAction } from '@ardoq/rxbeach';
import { api } from '@ardoq/api';
import {
  type ArdoqError,
  isArdoqError,
  type Result,
} from '@ardoq/common-helpers';
import { setupStatusCleared, setupStatusResolved } from './actions';

export type SetupStatus =
  | 'not-configured'
  | 'configuration-incomplete'
  | 's2e-not-installed';

const SETUP_STATUS_BY_ERROR_CODE: Record<string, SetupStatus> = {
  'transformations.notConfigured': 'not-configured',
  'transformations.configurationIncomplete': 'configuration-incomplete',
  // TODO: remove the legacy setup codes once the backend no longer returns them
  'transformations.setupNotRun': 'not-configured',
  'transformations.setupOutdated': 'configuration-incomplete',
  'transformations.s2eNotInstalled': 's2e-not-installed',
};

export const setupStatusFromError = (error: ArdoqError): SetupStatus | null => {
  if (
    !error.errorCode ||
    !Object.hasOwn(SETUP_STATUS_BY_ERROR_CODE, error.errorCode)
  ) {
    return null;
  }
  return SETUP_STATUS_BY_ERROR_CODE[error.errorCode];
};

// Temporary detection tap until the BE setup contract stabilizes: every
// transformationsApi call site pipes its response through
// `tap(result => dispatchDetectedSetupStatus(result))` so a setup-coded error from any endpoint
// raises the setup prompt (`setupPrompt$`).
export const dispatchDetectedSetupStatus = <T>(result: Result<T>): void => {
  if (!isArdoqError(result)) {
    dispatchAction(setupStatusCleared());
    return;
  }
  const status = setupStatusFromError(result);
  if (status) dispatchAction(setupStatusResolved(status));
};

export const logAndDetectSetupStatus = (error: ArdoqError): void => {
  api.logErrorIfNeeded(error);
  dispatchDetectedSetupStatus(error);
};
